import { render, staticRenderFns } from "./DefaultAudioguide.vue?vue&type=template&id=405c378d&"
import script from "./DefaultAudioguide.vue?vue&type=script&lang=ts&"
export * from "./DefaultAudioguide.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultAudioguide.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports